import { makeObservable, observable, action, computed } from 'mobx'
import { $evt, $consts } from 'src/plugins'

class AxiosStore {
  paths: string[]

  constructor () {
    this.paths = []
    this.register()

    makeObservable(this, {
      paths: observable,
      pending: computed,
      show: action,
      hide: action,
    })
  }

  register () {
    const handleShow = (url: string) => {
      this.show(url)
    }
    const handleHide = (url: string) => {
      this.hide(url)
    }

    $evt.addListener($consts['EVT/API_REQUEST_SUCCESS'], handleShow)
    $evt.addListener($consts['EVT/API_RESPONSE_SUCCESS'], handleHide)
    $evt.addListener($consts['EVT/API_RESPONSE_FAIL'], handleHide)
  }

  get pending () {
    let pending: any = { all: !!this.paths.length }
    this.paths.forEach((path: string) => {
      pending[path] = true
    })
    return pending
  }

  show (url: string) {
    this.paths = this.paths.concat(url)
  }

  hide (url: string) {
    this.paths = this.paths.filter((path: string) => path !== url)
  }
}

const axiosStore = new AxiosStore()

export default axiosStore